@if (
  question.presentation === "VERTICAL" || question.presentation === "HORIZONTAL"
) {
  <div
    [formGroup]="formGroup"
    [ngClass]="{
      'horizontal-scale': isScaleMode,
      'space-y-3': question.presentation === 'VERTICAL',
    }"
    [style.--scale-columns]="isScaleMode ? scaleColumns : null"
  >
    @for (alternative of question.alternatives; track $index) {
      <label
        [for]="alternative.id"
        [ngClass]="{
          'label-other': alternative.type === 'OTHER',
          'label-disabled':
            !!disabledCheckboxes[alternative.id] ||
            formGroup.get(alternative.id)?.disabled,
          'quota-error-alternative': hasQuotaError(alternative.id),
          'transition-transform-slow lg:hover:scale-y-[1.02] lg:hover:scale-x-[1.02]':
            question.presentation === 'HORIZONTAL',
          ' transition-transform-slow lg:origin-[20%_50%] lg:hover:scale-[1.01]':
            question.presentation === 'VERTICAL',
        }"
        class="min-w-14 text-base items-center font-normal flex gap-2 py-2 px-4 break-inside-avoid cursor-pointer md:hover:font-bold whitespace-normal break-words"
      >
        @if (alternative.id) {
          <div class="w-8 h-8 qb-checkbox qb-checkbox-outline flex-shrink-0">
            <input
              [id]="alternative.id"
              [formControlName]="alternative.id"
              [value]="
                alternative.type === 'OTHER'
                  ? alternative.id
                  : alternative.title
              "
              [attr.name]="question.id"
              [name]="question.id"
              [attr.aria-disabled]="
                !!disabledCheckboxes[alternative.id] ||
                formGroup.get(alternative.id)?.disabled
              "
              [attr.aria-describedby]="
                hasQuotaError(alternative.id)
                  ? 'quota-error-' + question.id
                  : null
              "
              [ngClass]="{
                'opacity-70':
                  disabledCheckboxes[alternative.id] ||
                  formGroup.get(alternative.id)?.disabled,
                'cursor-not-allowed':
                  disabledCheckboxes[alternative.id] ||
                  formGroup.get(alternative.id)?.disabled,
                'cursor-pointer':
                  !disabledCheckboxes[alternative.id] &&
                  !formGroup.get(alternative.id)?.disabled,
              }"
              (change)="onChange(alternative.id, alternative.type)"
              (click)="
                disabledCheckboxes[alternative.id] && onDisabledCheckboxClick
                  ? onDisabledCheckboxClick()
                  : null
              "
              type="checkbox"
              class="min-w-8"
              [attr.value]="
                alternative.type === 'OTHER'
                  ? alternative.id
                  : alternative.title
              "
            />
          </div>
        }

        @if (hasQuotaError(alternative.id)) {
          <app-icon
            [name]="Icon.Warning"
            class="w-6 h-6 validation-dynamic-theme"
            [attr.aria-label]="'validation.quota.alternative' | translate"
          ></app-icon>
        }

        <span
          id="label-{{ alternative.id }}"
          [title]="alternative.title"
          class="min-w-0 whitespace-normal break-words"
        >
          @if (alternative.image) {
            <img
              [src]="alternative.image.url"
              [alt]="alternative.image.alternateText || alternative.title"
              [style.width.px]="alternative.image.width"
              [style.height.px]="alternative.image.height"
              [style.object-fit]="'fill'"
              [style.display]="'block'"
            />
          }
          @if (!alternative.image?.hideTitle) {
            <span
              [innerHTML]="alternative.title | safeHtml"
              [attr.aria-label]="alternative.title"
              class="block whitespace-normal break-words"
            ></span>
          } @else {
            <span
              class="sr-only"
              [innerHTML]="alternative.title | safeHtml"
              [attr.aria-label]="alternative.title"
            ></span>
          }
        </span>
      </label>
    }
  </div>
}

@if (otherControl && (isOtherSelected || question.inPrintView)) {
  <div class="border-[1.5px] border-solid border-border-gray p-1">
    <textarea
      class="bg-inherit w-full px-2 py-1 resize-none"
      rows="3"
      [id]="question.id + '-other-input'"
      [formControl]="otherControl"
      [attr.aria-label]="'question.singleselect.otherinputlabel' | translate"
      [ngClass]="{
        'pr-9': otherControl.invalid && otherControl.touched,
      }"
    ></textarea>
    @if (otherControl.invalid && otherControl.touched) {
      <app-icon
        [name]="Icon.Warning"
        class="relative float-right bottom-[1.8rem] w-max validation-dynamic-theme"
      ></app-icon>
    }
    <div class="flex justify-between">
      <div>
        @if (otherControl.hasError("maxLength") && otherControl.touched) {
          <app-validator
            [question]="question"
            [validator]="ValidatorType.MaxLength"
            [control]="otherControl"
          ></app-validator>
        }
      </div>
      <p
        class="text-xs pl-2 pr-2"
        [ngClass]="{
          'validation-dynamic-theme': otherControl.value?.length > 255,
          '-mr-6': otherControl.invalid && otherControl.touched,
        }"
      >
        <span aria-hidden="true">
          {{ otherControl.value?.length ?? 0 }}/255</span
        >
      </p>
    </div>
  </div>
}
@if (statusMessage) {
  <p
    #statusMessageRef
    role="status"
    aria-live="polite"
    tabindex="-1"
    class="status-message flex items-center gap-2 mt-2 validation-dynamic-theme"
  >
    <app-icon
      [name]="Icon.Info"
      class="w-6 h-6 flex-shrink-0"
      [attr.aria-label]="'validation.general.info' | translate"
    ></app-icon>
    <span>{{ statusMessage }}</span>
  </p>
}
@if (formGroup.hasError("atLeastOneRequired") && hasFormGroupBeenTouched()) {
  <app-validator
    [question]="question"
    [validator]="ValidatorType.RequiredSelect"
    [multiMatrixQuestionTitle]="
      question.title + (columnTitle ? ' - ' + columnTitle : '')
    "
  />
}
@if (formGroup.touched || formGroup.dirty) {
  @for (alternative of question.alternatives; track alternative.id) {
    @if (formGroup.get(alternative.id)?.hasError("QuotaError")) {
      <app-validator
        [question]="question"
        [validator]="ValidatorType.QuotaError"
        [control]="formGroup.get(alternative.id)"
      />
    }
  }
}
